module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    on: {
      "click": function($event) {
        _vm.showModal = true
      }
    }
  }, [_vm._t("trigger")], 2), _vm._v(" "), (_vm.showModal) ? _c('div', {
    staticClass: "modal-mask",
    attrs: {
      "transition": "modal"
    },
    on: {
      "click": function($event) {
        _vm.showModal = false
      }
    }
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container modal-transition-container",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "modal-body"
  }, [_vm._t("content")], 2), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.cancel($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.cancelLabel))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.ok($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.confirmLabel))])])])])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2213117b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/generic/ConfirmModal.vue
// module id = 1024
// module chunks = 1